import { ARTICLE_TYPE } from "~types/types";

import { EYEBROW_OVERRIDES } from "./eyebrowUtil";

const PERSONALIZATION_SITES_OVERRIDES: {
    [key: string]: string;
} = {
    bview: "view",
    bpol: "politics",
    bbiz: "business",
};

export function getPersonalizationSitesOverride(site: string): string {
    const mappedSite = PERSONALIZATION_SITES_OVERRIDES[site] ?? site;
    return (
        EYEBROW_OVERRIDES[ARTICLE_TYPE.BASIC].brand[mappedSite]?.text ??
        mappedSite
    );
}
